// Accessible accordion (vanilla JS)
(function () {
	function initAccordion(accordionEl) {
		const buttons = Array.from(accordionEl.querySelectorAll('.a11y-accordion__button'));

		function getPanelFromButton(btn) {
			const panelId = btn.getAttribute('aria-controls');
			return panelId ? document.getElementById(panelId) : null;
		}

		function showPanel(btn, panel) {
			btn.setAttribute('aria-expanded', 'true');
			panel.classList.remove('is-offscreen');
		}

		function hidePanel(btn, panel) {
			btn.setAttribute('aria-expanded', 'false');
			panel.classList.add('is-offscreen');
		}

		function togglePanel(btn) {
			const panel = getPanelFromButton(btn);
			if (!panel) return;
			const expanded = btn.getAttribute('aria-expanded') === 'true';
			if (expanded) {
				hidePanel(btn, panel);
			} else {
				showPanel(btn, panel);
			}
		}

		function focusButtonAt(index) {
			if (index < 0) index = buttons.length - 1;
			if (index >= buttons.length) index = 0;
			buttons[index].focus();
		}

		buttons.forEach((btn, idx) => {
			// Click/Enter/Space toggle
			btn.addEventListener('click', () => togglePanel(btn));
			btn.addEventListener('keydown', (e) => {
				switch (e.key) {
					case ' ':
					case 'Enter':
						e.preventDefault();
						togglePanel(btn);
						break;
					case 'ArrowDown':
						e.preventDefault();
						focusButtonAt(idx + 1);
						break;
					case 'ArrowUp':
						e.preventDefault();
						focusButtonAt(idx - 1);
						break;
					case 'Home':
						e.preventDefault();
						focusButtonAt(0);
						break;
					case 'End':
						e.preventDefault();
						focusButtonAt(buttons.length - 1);
						break;
					default:
						break;
				}
			});
		});
	}

	function ready(fn) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', fn);
		} else {
			fn();
		}
	}

	ready(function () {
		document.querySelectorAll('[data-a11y-accordion]').forEach(initAccordion);
	});
})();